// extracted by mini-css-extract-plugin
export default {"container":"nav_dropdown_top-module__container--3q1YY"};